// React.
import PropTypes from 'prop-types';


function RefreshButton(props: { refresh: Function }) {
    const { refresh} = props;

    return (
            <button type="button" className="btn btn-heading d-none" data-tooltip-id="global-tooltip" data-tooltip-content="Refresh this view and the displayed data" onClick={() => refresh()}><i className="fal fa-redo fa-fw"></i></button>
    );
}

RefreshButton.propTypes = {
    refresh: PropTypes.func.isRequired
};

export default RefreshButton;
